import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import MetaHead from '../components/MetaHead';
import Layout from '../components/layouts/Layout';
import cookiePolicyHtml from '../components/policies/cookie-policy';

const CookiePolicyPage: FC<BootstrapPageProps> = () => (
  <>
    <MetaHead
      title="Cookie Policy | Wave.video"
      description="Cookie Policy."
    />

    <Layout navigationVariant="white" mainVariant="contain">
      <div dangerouslySetInnerHTML={{ __html: cookiePolicyHtml }} />
    </Layout>
  </>
);

export default bootstrapPage(CookiePolicyPage);
